const headerData = {
  authorName: {
    mainName: 'Eugeniusz Trecjak',
    subName: 'Yauhen Tretsyak'
  },
  portfolioPage: {
    PL: {
      mainLink: '/',
      mainLinkTitle: 'Główna',
      contactTitle: 'Kontakt'
    },
    EN: {
      mainLink: '/',
      mainLinkTitle: 'Main',
      contactTitle: 'Contact'
    }
  },
  mainPage: {
    PL: {
      mainLink: '/certificates',
      mainLinkTitle: 'Certyfikaty',
      contactTitle: 'Kontakt'
    },
    EN: {
      mainLink: '/certificates',
      mainLinkTitle: 'Certificates',
      contactTitle: 'Contact'
    }
  }
}

export { headerData };